<div class="images-block" *ngIf="currentImage" [class.images-block--slideshow]="images && images.length > 1">

  <div class="images-block__content">

    <div class="images-block__image-container" *ngIf="currentImage.urls">
      <app-image-view
        [src]="currentImage.urls.small"
        [fullscreenSrc]="currentImage.urls.default"
        [alt]="currentImage.alt"
        class="images-block__image-view"
        [fit]="fit"
        [fitSize]="fitSize">
      </app-image-view>
    </div>

    <app-html
      class="images-block__caption"
      *ngIf="currentImage.caption" 
      [markdownText]="currentImage.caption">
    </app-html>

    <div class="images-block__actions" *ngIf="images.length > 1">
      <button
        gaEvent
        gaAction="Clicked Previous Image"
        app-pin-button
        icon="chevron-left"
        size="small"
        buttonType="ghost" 
        matTooltip="Previous Image"
        (click)="handlePrevClick()">
      </button>

      <button
        gaEvent
        gaAction="Clicked Next Image"
        app-pin-button
        icon="chevron-right"
        size="small"
        buttonType="ghost" 
        matTooltip="Next Image"
        (click)="handleNextClick()">
      </button>
    </div>

  </div>

</div>